import { useAtom } from '@reatom/npm-react'
import styled from 'styled-components'

import { EditIcon } from '@blade/ui-kit'
import { CurrencyModel } from '@root/entities/currency'
import { CurrencyIcon } from '@root/entities/currency/ui'
import { TrendingEmojiIcon } from '@root/entities/premium/ui'
import { useTranslation } from '@root/shared/localization'

import type { Network } from '@root/entities/network'
import type { PremiumMetaModel } from '@root/entities/premium'

type Props = {
  network: Network.Network
  premium: PremiumMetaModel
  onEdit?: () => void
}

export const PremiumCurrencyDetailsEmoji: React.FC<Props> = ({
  premium,
  network,
  onEdit,
}) => {
  const { t } = useTranslation()
  const [trendingEmoji] = useAtom(premium.trendingEmoji)

  return (
    <Root>
      <Emoji>
        {trendingEmoji?.emojiId ? (
          <TrendingEmojiIcon emojiId={trendingEmoji.emojiId} size={24} />
        ) : (
          <CurrencyIcon currency={CurrencyModel.nativeOf(network)} size={24} />
        )}
      </Emoji>
      {t('premium.currency.emoji')}
      <EditEmojiIcon onClick={onEdit} size={19} />
    </Root>
  )
}

const Root = styled.div`
  background: var(--appearance-1);

  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: center;
  color: var(--text-12);

  gap: 6px;

  border-radius: 64px;
  padding: 2px;
`

const Emoji = styled.span`
  display: grid;
  justify-content: center;
  align-items: center;

  width: 24px;
  height: 24px;
  border-radius: 50%;
  font-size: 14px;
`

const EditEmojiIcon = styled(EditIcon)`
  margin: 0 8px;
  cursor: pointer;
`
